

const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
  agesections: [], // Liste des catégories
  currentAgesection: null, // Catégorie sélectionnée
  loading: false,
  error: null,
};

const agesectionsSlice = createSlice({
  name: "agesections",
  initialState,
  reducers: {
    setSectionsState: (state, { payload }) => {
      state.agesections = payload;
    },
    setSectionState: (state, { payload }) => {
      state.currentAgesection = payload;
    },
    setLoading: (state, { payload }) => {
      state.loading = payload;
    },
    setError: (state, { payload }) => {
      state.error = payload;
    },
  },
});

export const { setSectionsState, setSectionState, setLoading, setError } = agesectionsSlice.actions;
export default agesectionsSlice.reducer;